import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Custom hook to update document title based on current page and language
 * @param {string} titleKey - The i18n key for the page title (e.g., 'nav.home', 'nav.aircraft')
 * @param {string} fallbackEN - Fallback English title if i18n key not found
 * @param {string} fallbackTR - Fallback Turkish title if i18n key not found
 */
export const usePageTitle = (titleKey, fallbackEN = '', fallbackTR = '') => {
  const { t, language } = useLanguage();

  useEffect(() => {
    const pageTitle = t(titleKey) || (language === 'tr' ? fallbackTR : fallbackEN);
    const siteName = 'Kartal Air';
    
    document.title = pageTitle ? `${pageTitle} | ${siteName}` : siteName;

    // Cleanup: Reset to default when component unmounts
    return () => {
      document.title = 'Kartal Air | SUAS 2026';
    };
  }, [t, titleKey, language, fallbackEN, fallbackTR]);
};

/**
 * Page title mappings for reference
 * EN: Home | Kartal Air
 * TR: Ana Sayfa | Kartal Air
 * 
 * EN: Aircraft | Kartal Air
 * TR: Araç | Kartal Air
 * 
 * EN: Team | Kartal Air
 * TR: Takım | Kartal Air
 * 
 * EN: Build Logs | Kartal Air
 * TR: Yapım Günlükleri | Kartal Air
 * 
 * EN: Achievements | Kartal Air
 * TR: Başarılarımız | Kartal Air
 * 
 * EN: Sponsors | Kartal Air
 * TR: Sponsorlar | Kartal Air
 * 
 * EN: Contact | Kartal Air
 * TR: İletişim | Kartal Air
 */

export default usePageTitle;
